<template>
  <div class="error">Failed to load App. Try again later.</div>
</template>

<style scoped>
.error {
  color: red;
  font-weight: bold;
}
</style>
